// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Courses from "./pages/Courses";
import CourseDetails from "./pages/CourseDetails";
import ModuleList from "./pages/ModuleList";
import ModuleDetails from "./pages/ModuleDetails";
import Dashboard from "./pages/Dashboard";
import Certificate from "./pages/Certificate";
import Footer from "./components/Footer";
import InternshipPolicy from "./pages/InternshipPolicy"; 
import Apply from "./pages/Apply";

function App() {
  return (
    <Router>
      <Navbar />
      <div className="pt-20"> {/* offset for fixed navbar */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/courses/:id" element={<CourseDetails />} />
          <Route path="/courses/:id/modules" element={<ModuleList />} />
          <Route path="/courses/:id/modules/:moduleId" element={<ModuleDetails />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/certificate" element={<Certificate />} />
          <Route path="/internship-policy" element={<InternshipPolicy />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
